import {computed, Directive, input, signal, TemplateRef} from '@angular/core';

import {iconAttribute, IconType} from '../../icons';

@Directive({
  selector: '[pageTab]'
})
export class PageTabDirective {
  readonly pageTab = input.required<string>()
  readonly icon = input<IconType | null>(null)
  readonly rendered = signal(false)
  readonly tabId = computed(() => this.pageTab().toLowerCase().replace(/ /g, '-'))

  constructor(readonly template: TemplateRef<any>) { }
}
